import { WishlistTrackEventType } from '@awaze/mfe-common.contexts.wishlist'
import { Regions } from '@awaze/mfe-common.types-and-mocks.one-search-client'
import type { SearchCriteria } from '@awaze/mfe-common.types-and-mocks.site-search-service'
import { ICommonAggregations } from '@awaze/mfe-common.types-and-mocks.site-search-service/types/properties.types'
import {
  DataLayerEventType,
  DataLayerFactory,
  type SearchSubmitPayload,
  TmsContextType,
  WishlistAddRemovePropertyImpressionPayload,
} from '@awazevr/mfe-common.contexts.tms'

import { buildMapImpressionAndClickPayload } from '@/components/DynamicMap/DynamicMap.utils'
import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'
import { BuildApiUrlArgs, getPropertyInfo } from '@/utils/getPropertyInfo'

type GetPropertyInfoArgs = BuildApiUrlArgs

export const createSearchNoResultsPayload = (
  searchCriteria: SearchCriteria,
): SearchSubmitPayload => ({
  ...searchCriteria,
  adult: (searchCriteria.adult ?? '').toString(),
  child: (searchCriteria.child ?? '').toString(),
  infant: (searchCriteria.infant ?? '').toString(),
  nights: (searchCriteria.nights ?? '').toString(),
  pets: (searchCriteria.pets ?? '').toString(),
  range: (searchCriteria.range ?? '').toString(),
})

export const onWishlistTrack = async ({
  tms,
  eventName,
  clientHeader,
  currency,
  contentfulLocale,
  propertyInfoArgs,
  propertyImpression,
}: {
  tms: TmsContextType
  eventName: string
  clientHeader: string
  currency: string
  contentfulLocale: string
  propertyInfoArgs: GetPropertyInfoArgs
  propertyImpression: {
    aggregations: ICommonAggregations
    rhsLevel: Regions
    total: number
  }
}): Promise<void> => {
  const propertyInfo = await getPropertyInfo(
    propertyInfoArgs,
    clientHeader,
    currency,
    contentfulLocale,
  )

  if (propertyInfo?.property && tms) {
    new DataLayerFactory()
      .getEvent(DataLayerEventType.WishlistAddRemoveCard)
      .update(
        tms,
        {
          eventName: eventName,
          ...buildMapImpressionAndClickPayload(
            propertyInfoArgs.searchCriteria,
            propertyImpression.aggregations,
            propertyImpression.rhsLevel,
            propertyImpression.total,
            propertyInfo.property,
          ),
        } as WishlistAddRemovePropertyImpressionPayload,
        dataLayerErrorHandler,
      )
  }
}

export const wishlistTmsUpdateDataLayer = (
  tms: TmsContextType,
  event: WishlistTrackEventType,
  payload?: Record<string, unknown>,
): void => {
  tms.updateDataLayer('link', event, payload?.error_code ? payload : {})
}
